import React from 'react';
import { Flex, Text, Button, Content } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import S from './PairingFlow.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const imageOpts = {
  style: {
    height: '16px',
    width: '16px'
  }
};
export default function PairHome(props) {
  const {
    setTabId,
    areaClassName,
    onClose,
    titleVariant,
    titleIcon
  } = props;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Content.Header, {
      children: [/*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Pair & Unpair",
        icon: titleIcon
      }), /*#__PURE__*/_jsx(Button, {
        variant: "closeDialog",
        className: S.close,
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(Content.Area, {
      className: areaClassName,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        style: {
          height: '100%'
        },
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "formTitle",
          children: "Select Action"
        }), /*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "Pair a locator to a vehicle to receive real-time data gathering for that asset."
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "button.pairing.pairLocatorToVehicle",
          imageOpts: imageOpts,
          icon: "https://recovr-ui-assets.storage.googleapis.com/pair_button_icon.png",
          eventData: "pair",
          onClick: setTabId,
          variant: "pair|primary",
          children: "Pair Locator to Vehicle"
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "button.pairing.unpairLocatorFromVehicle",
          imageOpts: imageOpts,
          icon: "https://recovr-ui-assets.storage.googleapis.com/unpair_button_icon.png",
          eventData: "unpair",
          onClick: setTabId,
          variant: "unpair|secondary",
          children: "Unpair Locator from Vehicle"
        })]
      })
    })]
  });
}